import { PostManualUpload } from "services/apiService";
import { RESET_UPLOAD_MANUAL_ERROR,UPLOAD_MANUAL_ORDER_ERROR, UPLOAD_MANUAL_ORDER_SUCCESS, UPLOAD_MANUAL_ORDER_REQUEST, RESET_UPLOAD_MANUAL_ORDER } from "./action-type";
import { POST_AMENDMENT_REPORT } from "services/CONSTANTS";

export const uploadManualOrderFile = (payload) => {

    const { queryParams } = payload;
    const { params } = payload;
    const apiEndPointUrl = `users/userId/${POST_AMENDMENT_REPORT}?orderType=${queryParams.orderType}&fileName=${queryParams.fileName}&customerId=${queryParams.customerId}&amendCancelReasons=${queryParams.amendCancelReasons}&apikey=${payload.apiKey}`;
    return (dispatch) => {
        dispatch(uploadManualOrderRequest());
        PostManualUpload(apiEndPointUrl, params)
            .then((response) => {
                if (response.status === 200)
                    dispatch(uploadManualOrderSuccess(response));
                else
                    dispatch(uploadManualOrderError(response));
            })
            .catch((err) => {
               
                dispatch(uploadManualOrderError(err.response.data));
            });

    };
};

export const uploadManualOrderSuccess = (response) => {
    return {
        type: UPLOAD_MANUAL_ORDER_SUCCESS,
        uploadManualOrderResponse: response.data,
        isuploadManualOrderError: false,
        isuploadManualOrderSuccess: true,
        errorDetails:{}
    }
};


export const uploadManualOrderRequest = () => {
    return {
        type: UPLOAD_MANUAL_ORDER_REQUEST
    }
};

export const uploadManualOrderError = (error) => {

    return {
        type: UPLOAD_MANUAL_ORDER_ERROR,
        uploadManualOrderResponse: error,
        isuploadManualOrderError: true,
        isuploadManualOrderSuccess: false,
        errorDetails:error
    }
};


export const resetUploadManualOrder = () => { 
    return { 
        type: RESET_UPLOAD_MANUAL_ORDER 
    };
 };

 export const resetUploadManualError = () => { 
    return { 
        type: RESET_UPLOAD_MANUAL_ERROR
    };
 };


 export const showErrorMessageByCode = err => {
    const { response } = err;

    if (err?.code === "ERR_NETWORK") {
        return {
            errTitle: "No Network Connection",
            errContent: "Unable to connect to the server. Please check your internet connection and try again."
        }
    }

    switch (response?.status) {
        case 400: return {
            errTitle: "400 - Invalid Input",
            errContent: `The data provided is incorrect or improperly formatted. Please review your input
            and ensure that all required fields are filled-out accurately. If you continue to
            experience this issue, please contact our support team for assistance.`
        };
        case 403: return {
            errTitle: "403 - Forbidden",
            errContent: `Access Denied. You do not have the necessary permissions to view or interact with
            this content. If you believe this is in error, please contact our support team for
            assistance.`
        };
        case 404: return {
            errTitle: "404 - Resource not found",
            errContent: "The resource you are looking for was not found."
        }
        case 500: return {
            errTitle: "Something went wrong",
            errContent: `We're sorry, but something went wrong on our end. Please try again later.
            Feel free to contact our support if the problem persists.`
        };
        case 503: return {
            errTitle: "Something went wrong",
            errContent: `Our services are currently undergoing maintenance or experiencing heavy load.
            We apologize for the inconvenience. Please try again later. If the issue persists,
            feel free to contact our support team for updates.`
        }
        default: return {
            errTitle: "Error",
            errContent: `We're sorry, but something went wrong on our end. Please try again later.
            Feel free to contact our support if the problem persists.`
        }
    }
}